import type { TabSpecState } from "../../runtime/tabSpecStore"
import { valuesPending } from "../../runtime/valueCheck"

/**
 * Whether "Run tab book" can start, and why not: the header's tooltip. A
 * book needs a ready data session, the questionnaire (nothing runs without
 * it), the routing read to its end (available or not), the values of every
 * number an included table shows value by value (the values check), and at
 * least one included table. A book that is already running does not
 * disable it: the dialog then shows that book.
 */
export const runAvailability = (
  state: TabSpecState
): { canRun: boolean; reason: string | null } => {
  const { status } = state.session
  if (status === "no-data") return { canRun: false, reason: "Import data first." }
  if (status !== "ready")
    return { canRun: false, reason: "The data session is not ready." }
  if (!state.catalogue)
    return { canRun: false, reason: "The questionnaire is not loaded." }
  // A book now would run its tables on a routing that is about to change.
  if (state.catalogue.routingLoading)
    return { canRun: false, reason: "Checking who was asked each question." }
  // Such a table waits for its values: in a book now it would be skipped.
  if (valuesPending(state))
    return { canRun: false, reason: "Reading the values of the numbers shown value by value." }
  if (!state.document.tables.some((t) => t.include))
    return { canRun: false, reason: "No table is included." }
  return { canRun: true, reason: null }
}
